import { CompRef, ValueOf } from '@wix/document-services-types';
import { AbstractExternalAPIHandler } from './AbstractExternalAPIHandler';
import { LAYOUT } from '@wix/component-protocol/schema';
import { DependencyToken } from '../dependencies';
import type { EditorPointer } from '@wix/editor-document-logic-api';

export class ExternalStageHandler extends AbstractExternalAPIHandler {
  private readonly defaultBreakpoint = LAYOUT.BREAKPOINT.large;

  getBreakpointFromPointer(editorPointer: EditorPointer<CompRef>) {
    const getBreakpoint = this.dependenciesContributor.get(
      DependencyToken.STAGE_BREAKPOINT_GET,
    );
    return getBreakpoint(editorPointer) ?? this.defaultBreakpoint;
  }

  getPointerWithBreakpointVariant(
    editorPointer: EditorPointer<CompRef>,
    breakpoint: ValueOf<typeof LAYOUT.BREAKPOINT>,
  ) {
    try {
      const getPointerWithBreakpointVariant = this.dependenciesContributor.get(
        DependencyToken.STAGE_BREAKPOINT_POINTER_GET,
      );

      return getPointerWithBreakpointVariant(editorPointer, breakpoint);
    } catch (error) {
      console.error('getPointerWithBreakpointVariant failed', error);
      return null;
    }
  }
}
